const GAME_ID_TO_CODE = {
  "single-digit": "single_digits",
  "single-digit-bulk": "single_digits",
  "jodi-digit": "jodi",
  "jodi-digit-bulk": "jodi",
  "single-pana": "single_pana",
  "single-panna": "single_pana",
  "single-pana-bulk": "single_pana_bulk",
  "single-panna-bulk": "single_pana_bulk",
  "double-pana": "double_pana",
  "double-panna": "double_pana",
  "double-pana-bulk": "double_pana_bulk",
  "double-panna-bulk": "double_pana_bulk",
  "triple-pana": "triple_pana",
  "triple-panna": "triple_pana",
  "tripple-pana": "triple_pana",
  "tripple-panna": "triple_pana",
  "half-sangam-a": "half_sangam_a",
  "half-sangam-b": "half_sangam_b",
  "full-sangam": "full_sangam",
  "sp-motor": "sp_motor",
  "dp-motor": "dp_motor",
  "panel-group": "panel_group",
  "red-bracket": "red_bracket",
  "two-digit-panel": "two_digits_panel",
  "sp-dp-tp": "sp_dp_tp",
  "choice-pana": "choice_pana",
  "digit-based-jodi": "digits_based_jodi",
  "group-jodi": "group_jodi",
  "odd-even": "odd_even",
};

const MIXED_CODES = new Set(["two_digits_panel", "sp_dp_tp", "choice_pana"]);

const SERIES_BET_TYPE = {
  sp: "single_pana",
  dp: "double_pana",
  tp: "triple_pana",
};

const SUB_TYPE_LABEL = {
  single_pana: "SP",
  double_pana: "DP",
  triple_pana: "TP",
  jodi: "Jodi",
  sp: "SP",
  dp: "DP",
  tp: "TP",
};

export function resolveBetTypeCode(gameType) {
  if (gameType?.code && GAME_ID_TO_CODE[gameType.id] !== "single_digits") {
    return gameType.code;
  }
  if (gameType?.id === "single-digit" || gameType?.id === "single-digit-bulk") {
    return gameType.code && gameType.code !== "single_digit_bulk"
      ? gameType.code
      : "single_digits";
  }
  return gameType?.code || GAME_ID_TO_CODE[gameType?.id] || "";
}

export function normalizeSession(value) {
  return String(value || "open").toLowerCase() === "close" ? "close" : "open";
}

function bidDigits(bid) {
  const raw = bid?.digit ?? bid?.jodi ?? bid?.pana ?? bid?.panna;
  return raw == null ? "" : String(raw).trim();
}

function toApiDigits(betTypeCode, digits) {
  if (betTypeCode !== "half_sangam_a") return digits;
  const [left, right] = digits.split("-");
  if (left && right && left.length === 1 && right.length === 3) {
    return `${right}-${left}`;
  }
  return digits;
}

function inferPanelBetType(digits) {
  if (digits.length <= 2) return "jodi";
  if (digits.length === 3 && digits[0] === digits[1] && digits[1] === digits[2]) {
    return "triple_pana";
  }
  if (
    digits.length === 3 &&
    (digits[0] === digits[1] || digits[1] === digits[2] || digits[0] === digits[2])
  ) {
    return "double_pana";
  }
  return "single_pana";
}

function betTypeForSelection(betTypeCode, bid, digits) {
  if (!MIXED_CODES.has(betTypeCode)) return undefined;
  if (bid?.series && SERIES_BET_TYPE[bid.series]) return SERIES_BET_TYPE[bid.series];
  if (betTypeCode === "two_digits_panel") return inferPanelBetType(digits);
  return undefined;
}

function rowsFromDigitPoints(digitPoints, session) {
  if (!digitPoints) return [];
  return Object.entries(digitPoints).map(([digit, points]) => ({
    id: digit,
    digit,
    points,
    gameType: session,
  }));
}

export function buildMatkaBetDraft({ gameType, session, bids, digitPoints }) {
  const betTypeCode = resolveBetTypeCode(gameType);
  const normalizedSession = normalizeSession(session);
  const source = Array.isArray(bids) ? bids : rowsFromDigitPoints(digitPoints, session);
  const rows = [];
  const selections = [];

  source.forEach((bid) => {
    const selectionText = bidDigits(bid);
    const points = Number(bid.points);
    if (!selectionText || !Number.isFinite(points) || points <= 0) return;

    const apiDigits = toApiDigits(betTypeCode, selectionText);
    const subType = betTypeForSelection(betTypeCode, bid, apiDigits);
    rows.push({
      id: bid.id ?? selectionText,
      selection: selectionText,
      points,
      gameType: String(bid.gameType || session || normalizedSession).toUpperCase(),
      subType: SUB_TYPE_LABEL[subType] || SUB_TYPE_LABEL[bid.series] || "",
    });

    const selection = { digits: apiDigits, points };
    if (subType) selection.bet_type = subType;
    selections.push(selection);
  });

  return { betTypeCode, session: normalizedSession, rows, selections };
}
